import { createSelector } from 'reselect'
import {parsePeriod} from 'utils/stuff'
import { owners, properties, historyPrice, leases, listings } from './entities'
import { startMarketDateByPropertyID } from './perfomance'
import { currentUser } from './common'
import { transactionsEx } from './transactions'
import incomeStatement from 'helpers/kpi/incomeStatement'
import monthlyStatement from 'helpers/kpi/monthlyStatement'
import balance from 'helpers/kpi/balance'
import breakdown from 'helpers/kpi/breakdown'
import equity from 'helpers/kpi/equity'
import * as R from 'ramda'
import moment from 'moment'

export let reportPeriod = (state) => state.finance.period
export let reportInterval = (state) => parsePeriod(state.finance.period)

export let reportType = state => state.finance.report

export let reportPropertyID = state => state.finance.property
export let reportProperty = createSelector([properties, reportPropertyID], (properties, propertyID) => properties[propertyID] && properties[propertyID].alias)

export let incomeStatementData = createSelector([transactionsEx, properties, leases, listings, startMarketDateByPropertyID, reportInterval], (transactions, properties, leases, listings, startMarketDateByPropertyID, period) => incomeStatement(transactions, properties, leases, listings, startMarketDateByPropertyID, period))
export let monthlyStatementData = createSelector([transactionsEx, properties, reportInterval], (transactions, properties, period) => R.pipe(
	R.map(statement => {
		// debugger
		let total = statement.total
		let sorted = R.pipe(
			R.omit('total')
		  , R.mapObjIndexed((amount, propertyID) => ({amount, propertyAlias: properties[propertyID] && properties[propertyID].alias}))
		  , R.values
		  , R.sortBy(R.prop('propertyAlias'))
		  , R.append({amount: total, propertyAlias: 'Total'})
		)(statement)
		return sorted
	})
)(monthlyStatement(transactions, period)))

export let priorBalance = createSelector([transactionsEx, owners, reportInterval], (transactions, owners, period) => balance(transactions, owners, period.from))
export let currentBalance = createSelector([transactionsEx, owners, reportInterval], (transactions, owners, period) => balance(transactions, owners, period.to))

export let zestimateStart = createSelector([historyPrice, reportInterval], (historyPrice, period) => getClosestHistoryPrice(historyPrice, period.from))
export let zestimateEnd = createSelector([historyPrice, reportInterval], (historyPrice, period) => getClosestHistoryPrice(historyPrice, period.to))

export let loanBalanceStart = createSelector([properties, reportInterval], (properties, period) => breakdown(properties, period.from))
export let loanBalanceEnd = createSelector([properties, reportInterval], (properties, period) => breakdown(properties, period.to))

export let equityByPeriod = createSelector([historyPrice, properties, reportInterval], (historyPrice, properties, period) => equity(historyPrice, properties, period.from))
export let breakdownByPeriod = createSelector([properties, reportInterval], (properties, period) => breakdown(properties, period.to))

export let ownerName = createSelector([owners, currentUser], (owners, ownerID) => owners[ownerID] && owners[ownerID].firstName)
let templates = state => state.finance.templates

export let currentTemplate = createSelector([reportType, templates], (report, templates) => templates[report])

let currUser = createSelector([owners, currentUser], (owners, ownerID) => owners[ownerID])
export let getReport = createSelector([reportPeriod, currentTemplate, currUser],
	(period, template, user) => {
		let res = user && template && template.replace("{{NAME}}", user.firstName)
		return res
	}
)

let getClosestHistoryPrice = (historyPrice, date) =>{
	let historyByPropertyID = R.pipe(R.values, R.groupBy(R.prop('propertyID')))(historyPrice)
	let res = R.map(propertyHistory => {
		let latestHistory = R.pipe(R.sortBy(R.prop('date')), R.findLast(x => x.date <= moment(date).format('YYYY-MM-DD')))(propertyHistory)
		return latestHistory.price
	})(historyByPropertyID)
	res.total = R.pipe(R.values, R.reduce(R.add, 0))(res)
	return res
}



// WEBPACK FOOTER //
// ./src/selectors/reports.js